
export abstract class IDisposable {
  abstract dispose(): void
}
